import { useEffect } from "react";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Testimonials from "@/components/Testimonials";
import Videos from "@/components/Videos";
import ApplicationForm from "@/components/ApplicationForm";
import Footer from "@/components/Footer";
import StickyApply from "@/components/StickyApply";
import { applyOverrides } from "@/builder/overrides";
import { initTracker } from "@/tracker";

export function Landing() {
  useEffect(() => {
    if (window.location.pathname.startsWith("/builder")) return;
    const stopTracking = initTracker();
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/builder/published`)
      .then((r) => r.json())
      .then((ov) => {
        if (ov && ov.elements) {
          const root = document.getElementById("public-root");
          if (root) setTimeout(() => applyOverrides(root, ov, "public"), 150);
        }
      })
      .catch(() => {});
    return stopTracking;
  }, []);

  return (
    <div id="public-root" className="min-h-screen bg-[#0a0a0a] font-sans text-white antialiased">
      <div className="grain-overlay" aria-hidden="true" />
      <Nav />
      <main>
        <Hero />
        <ApplicationForm />
        <Marquee />
        <Testimonials />
        <Manifesto />
        <Videos />
      </main>
      <Footer />
      <StickyApply />
    </div>
  );
}
